import { Fragment } from "react";
import { Grid, Typography, Chip } from "@mui/material";

import { colors } from "../../css components/Style";

export default function FormThree({ formikProps }) {
  function handleClick(url) {
    window.open(url, "_blank");
  }

  return (
    <Fragment>
      <Grid size={12} display={"flex"} gap="10px">
        <div className="div-upload-document">
          <Typography color={colors.purple}>Company GST Certificate</Typography>

          {!!formikProps.values.gstCertificate && (
            <Chip
              className="file-chip"
              style={{
                borderColor: colors.green,
                color: colors.green,
              }}
              label={formikProps.values.gstCertificate?.split("_").pop()}
              variant="outlined"
              onClick={() => handleClick(formikProps.values.gstCertificate)}
            />
          )}
        </div>

        <div className="div-upload-document">
          <Typography color={colors.purple}>Company PAN Certificate</Typography>

          {!!formikProps.values.companyPanCertificate && (
            <Chip
              className="file-chip"
              style={{
                borderColor: colors.green,
                color: colors.green,
              }}
              label={formikProps.values.companyPanCertificate?.split("_").pop()}
              variant="outlined"
              onClick={() =>
                handleClick(formikProps.values.companyPanCertificate)
              }
            />
          )}
        </div>

        <div className="div-upload-document">
          <Typography color={colors.purple}>
            Company Director's Aadhaar Certificate
          </Typography>

          {!!formikProps.values.directorAadharCertificate && (
            <Chip
              className="file-chip"
              style={{
                borderColor: colors.green,
                color: colors.green,
              }}
              label={formikProps.values.directorAadharCertificate
                ?.split("_")
                .pop()}
              variant="outlined"
              onClick={() =>
                handleClick(formikProps.values.directorAadharCertificate)
              }
            />
          )}
        </div>

        <div className="div-upload-document">
          <Typography color={colors.purple}>
            Company Director's PAN Certificate
          </Typography>

          {!!formikProps.values.directorPanCertificate && (
            <Chip
              className="file-chip"
              style={{
                borderColor: colors.green,
                color: colors.green,
              }}
              label={formikProps.values.directorPanCertificate
                ?.split("_")
                .pop()}
              variant="outlined"
              onClick={() =>
                handleClick(formikProps.values.directorPanCertificate)
              }
            />
          )}
        </div>
      </Grid>
    </Fragment>
  );
}
